import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from './api';

const PasswordResetForm = () => {
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);
    const { token } = useParams();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (newPassword !== confirmPassword) {
            setMessage('パスワードが一致しません。');
            return;
        }

        if (newPassword.length < 8) {
            setMessage('パスワードは8文字以上で入力してください。');
            return;
        }

        try {
            const response = await axios.post(`/reset-password/${token}`, { new_password: newPassword });
            setIsSuccess(true);
            setMessage(response.data.message);
        } catch (error) {
            setMessage(error.response?.data?.error || 'エラーが発生しました。');
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-form-container">
                <h2>パスワードリセット</h2>
                {!isSuccess && (
                    <form onSubmit={handleSubmit} className="auth-form">
                        <label className="auth-label">新しいパスワード</label>
                        <input
                            type="password"
                            placeholder="新しいパスワードを入力"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            required
                            className="auth-input"
                        />
                        <label className="auth-label">パスワード（再入力）</label>
                        <input
                            type="password"
                            placeholder="パスワードをもう一度入力"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                            className="auth-input"
                        />
                        <button type="submit" className="auth-button">パスワードを変更する</button>
                    </form>
                )}
                {isSuccess && (
                    <button onClick={() => navigate('/login')} className="auth-button">
                        ログイン画面に移動
                    </button>
                )}
                {message && <p className="auth-message">{message}</p>}
            </div>
        </div>
    );
};

export default PasswordResetForm;
